import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TractorsHistoryPopupComponent } from './tractors-history-popup.component';
import {DxFormModule, DxLoadPanelModule, DxPopupModule} from 'devextreme-angular';



@NgModule({
  declarations: [TractorsHistoryPopupComponent],
  imports: [
    CommonModule,
    DxPopupModule,
    DxFormModule,
    DxLoadPanelModule
  ],
  exports: [TractorsHistoryPopupComponent]
})
export class TractorsHistoryPopupModule { }
